import CardWrapper from '@components/UI/CardWrapper';
import { Popper } from '@material-ui/core';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Autocomplete from '@mui/material/Autocomplete';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { ItemSelector } from '@services/requests/companyProfileService/interface';
import { MainData } from '@services/requests/companyProfileService/types/mainData';
import React from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';

import {
  CompanyProfileExtendedFormFields,
  CompanyProfileFormFields,
} from '../../CompanyProfileModulesWrapper/types';
import { EdoModuleStyledContainer } from './StyledComponents';

interface EdoModuleProps {
  isEditMode: boolean;
  form: UseFormReturn<
    CompanyProfileFormFields & CompanyProfileExtendedFormFields,
    any,
    CompanyProfileFormFields & CompanyProfileExtendedFormFields
  >;
  mainData: MainData;
}

const CustomPopper = (props: any) => {
  return (
    <Popper
      {...props}
      placement="bottom"
      style={{ width: props.anchorEl.clientWidth, minWidth: "fit-content" }}
    />
  );
};

function EdoModule({ isEditMode, form, mainData }: EdoModuleProps) {
  const { fields } = mainData.sections.edo;

  const {
    control,
    formState: { errors },
  } = form;

  return (
    <EdoModuleStyledContainer>
      <CardWrapper sx={{ padding: '25px 40px' }} className="card">
        <Typography variant={'h3'} className={'module-title'}>
          {mainData.sections.edo.caption}:
        </Typography>
        <div className="other-info-wrapper">
          {/* <Controller
            control={control}
            name="availabilityEdo"
            render={({ field: { onChange, value, ref, onBlur, name } }) => (
              <TextField
                fullWidth
                type="text"
                className="comment-field"
                size={'medium'}
                disabled={!isEditMode}
                label={t('CompanyProfile:Edo.AvailabilityEdo')}
                variant="outlined"
                name={name}
                onChange={onChange}
                onBlur={onBlur}
                ref={ref}
                value={value || ''}
                error={!!errors.availabilityEdo}
              />
            )}
          /> */}
          <Controller
            control={control}
            name="availabilityEdo"
            render={({ field: { onChange, value, ref, onBlur } }) => (
              <Autocomplete
                disablePortal
                fullWidth
                className="availability-edo"
                PopperComponent={CustomPopper}
                options={fields.edo.items ?? []}
                disabled={!isEditMode}
                onChange={(_, value) => onChange(value ? value.code : null)}
                onBlur={onBlur}
                ref={ref}
                value={
                  typeof value === 'number'
                    ? (fields.edo.items ?? []).find((c) => c.code === value) ?? null
                    : null
                }
                popupIcon={<KeyboardArrowDownIcon />}
                classes={{ input: 'browser-default' }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={fields.edo.title}
                    error={!!errors.availabilityEdo}
                  />
                )}
                renderOption={(props, option) => {
                  return (
                    <MenuItem
                      {...props}
                      value={option.code}
                      key={option.code}
                      className="a-service-field-selector-option--root"
                    >
                      {option.title}
                    </MenuItem>
                  );
                }}
                getOptionLabel={(option: ItemSelector<number>) => option.title}
              />
            )}
          />
          <Controller
            control={control}
            name="operatorEdo"
            render={({ field: { onChange, value, name, onBlur, ref } }) => (
              <TextField
                fullWidth
                type="text"
                className="comment-field"
                size={'medium'}
                disabled={!isEditMode}
                label={fields.edo_operator.title}
                variant="outlined"
                name={name}
                onBlur={onBlur}
                ref={ref}
                onChange={onChange}
                value={value || ''}
                error={!!errors.operatorEdo}
                InputProps={{ classes: { input: 'browser-default' } }}
              />
            )}
          />
        </div>
      </CardWrapper>
    </EdoModuleStyledContainer>
  );
}
export { EdoModule };
